(function () {
  function initFLVConsent() {
    const checkbox = document.getElementById('flv_legal_checkbox');
    const error = document.getElementById('flv_legal_error');
    if (!checkbox) return;

    const checkoutSelectors = [
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      'a[href^="/checkout"]',
      'form[action^="/checkout"] button[type="submit"]'
    ];

    const getCheckoutTargets = () =>
      checkoutSelectors.flatMap(sel => Array.from(document.querySelectorAll(sel)));

    const showError = (show) => {
      if (!error) return;
      error.style.display = show ? 'block' : 'none';
    };

    const setDisabled = (disabled) => {
      getCheckoutTargets().forEach(el => {
        const tag = el.tagName.toLowerCase();
        if (tag === 'button' || tag === 'input') {
          el.disabled = disabled;
          el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
      });
    };

    async function saveConsent(checked) {
      const body = new URLSearchParams();
      body.append('attributes[legal_consent]', checked ? 'yes' : 'no');
      body.append('attributes[legal_consent_timestamp]', checked ? new Date().toISOString() : '');
      body.append('attributes[legal_consent_policy_version]', checked ? '2026-01-01' : '');

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString()
      });
    }

    // état initial
    setDisabled(true);

    checkbox.addEventListener('change', async () => {
      showError(false);
      setDisabled(!checkbox.checked);
      try { await saveConsent(checkbox.checked); } catch (e) {}
    });

    // bloque toute tentative d'aller au checkout si pas coché
    document.addEventListener('click', (e) => {
      const target = e.target.closest(checkoutSelectors.join(','));
      if (!target) return;

      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        showError(true);
        checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);

    // Impact peut rerender des blocs → on ré-applique l'état
    const mo = new MutationObserver(() => setDisabled(!checkbox.checked));
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFLVConsent);
  } else {
    initFLVConsent();
  }

  document.addEventListener('shopify:section:load', initFLVConsent);
})();